import React from "react";
import { HeartIcon } from "@aureskonnect/react-ui";
import { Tooltip } from "@material-ui/core";
import classnames from "classnames";
import ErrorToast from "@components/Common/ErrorTost";

function FavoriteButton({
    e,
    oneShop,
    isEdited,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setRowData,
    setShopId,
    setSale,
    favoriteModeOfSale,
    unfavoriteModeOfSale,
    isModeOfSaleArchived,
    isLoading,
    t,
    setModalState,
}: any) {
    const handleFavoriteClick = ({
        selectedRow,
        oneShop,
        isEdited,
        setIsActionsClicked,
        setActions,
        setIsEdited,
        setRowData,
        setShopId,
        setSale,
        favoriteModeOfSale,
        unfavoriteModeOfSale,
        t,
    }: any) => {
        if (selectedRow.isFavorite === false) {
            if (selectedRow.state === false && oneShop) {
                ErrorToast(
                    t(
                        "Please note, you cannot activate the favorite state for a disabled mode of sale"
                    )
                );
            } else {
                if (isEdited === true) {
                    setIsActionsClicked((prev: any) => !prev);
                    setActions(() => {
                        setIsEdited(false);
                        setModalState((prev: any) => ({
                            ...prev,
                            isAddModeOfSaleClicked: false,
                        }));
                        setRowData(selectedRow);
                        setShopId(selectedRow.shopId);
                        setSale(selectedRow);
                        if (selectedRow.isFavorite) {
                            unfavoriteModeOfSale();
                        } else {
                            favoriteModeOfSale();
                        }
                    });
                } else {
                    setModalState((prev: any) => ({
                        ...prev,
                        isAddModeOfSaleClicked: false,
                    }));
                    setRowData(selectedRow);
                    setShopId(selectedRow.shopId);
                    setSale(selectedRow);
                    if (selectedRow.isFavorite) {
                        unfavoriteModeOfSale();
                    } else {
                        favoriteModeOfSale();
                    }
                }
            }
        }
    };

    return (
        <Tooltip
            title={
                isModeOfSaleArchived || e.selectedRow.isFavorite
                    ? ""
                    : t("Enable favorite state")
            }
        >
            <div>
                <HeartIcon
                    onClick={() =>
    !isLoading &&
                        handleFavoriteClick({
                            selectedRow: e.selectedRow,
                            oneShop,
                            isEdited,
                            setIsActionsClicked,
                            setActions,
                            setIsEdited,

                            setRowData,
                            setShopId,
                            setSale,
                            favoriteModeOfSale,
                            unfavoriteModeOfSale,
                        })
                    }
                    height={25}
                    width={25}
                    name="heart"
                    fill={e.selectedRow.isFavorite ? "red" : "black"}
                    className={classnames(
                        "mdv_icn_FRlike",
                        {
                            "not-allowed-icon__clz":
                                isModeOfSaleArchived || isLoading,
                        },
                        {
                            pointer__clz: !e.selectedRow.isFavorite,
                        },
                        oneShop ? "mr-2" : ""
                    )}
                />
            </div>
        </Tooltip>
    );
}

export default FavoriteButton;
